var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageLayoutForms", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "h1",
              {
                staticClass:
                  "pdp-mandate-onboarding-company__title typographies-heading-h1"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t.__("pdp.mandate.Onboarding.title")) +
                    "\n        "
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("InformationBanner", {
              staticClass: "pdp-mandate-onboarding-company__information-banner",
              attrs: {
                title: _vm.$t.__(
                  "pdp.mandate.OnboardingCompany.InformationBanner.title"
                ),
                sourceIllustration:
                  "/ressources/logged/img/illustrations/pdp/user-identity.svg"
              },
              scopedSlots: _vm._u([
                {
                  key: "description",
                  fn: function() {
                    return [
                      _c("div", {
                        staticClass:
                          "pdp-mandate-onboarding-company__information typographies-paragraph-medium-regular",
                        domProps: {
                          innerHTML: _vm._s(_vm.informationBannerDescription)
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pdp-mandate-onboarding-company__form-item" },
              [
                _c(
                  "CompassFormItem",
                  {
                    attrs: {
                      label: _vm.$t.__(
                        "pdp.mandate.OnboardingCompany.formItem.company"
                      ),
                      size: "large"
                    }
                  },
                  [
                    _c("CompassAutoComplete", {
                      attrs: {
                        size: "large",
                        multiple: true,
                        multipleLimit: 1,
                        results: _vm.searchResults,
                        noResultsLabel: _vm.$t.__(
                          "common.labels.no_match_found"
                        ),
                        placeholder: _vm.$t.__(
                          "pdp.mandate.OnboardingCompany.formItem.company.placeholder"
                        ),
                        menuClass:
                          "pdp-mandate-onboarding-company__company-search",
                        loading: _vm.loadingCompanySearch
                      },
                      on: {
                        change: _vm.handleCompanySelect,
                        "update-search": _vm.handleCompanySearch
                      },
                      model: {
                        value: _vm.form.company,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "company", $$v)
                        },
                        expression: "form.company"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "pdp-mandate-onboarding-company__help typographies-paragraph-small-semibold"
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t.__(
                              "pdp.mandate.OnboardingCompany.formItem.company.help"
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("CompassPlainButton", {
                      attrs: {
                        label: _vm.$t.__(
                          "pdp.mandate.OnboardingCompany.support_button"
                        ),
                        size: "small"
                      },
                      on: { click: _vm.openIntercom }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showCompanyInformation
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pdp-mandate-onboarding-company__company-information"
                        },
                        [
                          _c(
                            "CompassDescriptionList",
                            { attrs: { size: "small" } },
                            _vm._l(Object.values(_vm.form.company[0]), function(
                              item,
                              index
                            ) {
                              return _c(
                                "CompassDescriptionListItem",
                                { key: index, attrs: { label: item.label } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.value) +
                                      "\n                        "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pdp-mandate-onboarding-company__company-information-help"
                        },
                        [
                          _c("img", {
                            attrs: {
                              src:
                                "/ressources/logged/img/illustrations/pdp/information.svg",
                              alt: "Information",
                              height: "20",
                              width: "20"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "typographies-paragraph-medium-regular"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t.__(
                                      "pdp.mandate.OnboardingCompany.formItem.company_information.help"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pdp-mandate-onboarding-company__form-item" },
              [
                _c(
                  "CompassFormItem",
                  {
                    attrs: {
                      label: _vm.$t.__(
                        "pdp.mandate.OnboardingCompany.formItem.legal_representative"
                      ),
                      size: "large",
                      info: _vm.$t.__(
                        "pdp.mandate.OnboardingCompany.formItem.legal_representative.info"
                      )
                    }
                  },
                  [
                    _c(
                      "CompassSelect",
                      {
                        attrs: {
                          size: "large",
                          menuClass:
                            "pdp-mandate-onboarding-company__company-legal-representative"
                        },
                        model: {
                          value: _vm.form.legalRepresentative,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "legalRepresentative", $$v)
                          },
                          expression: "form.legalRepresentative"
                        }
                      },
                      _vm._l(_vm.legalRepresentatives, function(item) {
                        return _c("CompassDropdownSelectOption", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "pdp-mandate-onboarding-company__help typographies-paragraph-small-semibold"
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t.__(
                              "pdp.mandate.OnboardingCompany.formItem.legal_representative.help"
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("CompassPlainButton", {
                      attrs: {
                        label: _vm.$t.__(
                          "pdp.mandate.OnboardingCompany.support_button"
                        ),
                        size: "small"
                      },
                      on: { click: _vm.openIntercom }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("FooterFullPage", {
              attrs: {
                primaryAction: _vm.primaryAction,
                secondaryActions: _vm.secondaryActions
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }